import { AppIcon } from '@backrs_ui/common-ui';

import type { AppIcons, IconSize } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { IconButton, Theme, Tooltip } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

type EditorToolbarButtonProps = Readonly<{
  id: string;
  label: string;
  icon: AppIcons;
  iconSize?: IconSize;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
}>;

export const EditorToolbarButton = ({
  id,
  label,
  icon,
  iconSize = '20px',
  active,
  disabled,
  onClick,
}: EditorToolbarButtonProps) => (
  <Tooltip title={label} disableInteractive enterDelay={400}>
    <span>
      <IconButton
        id={id}
        aria-label={label}
        aria-pressed={active}
        disabled={disabled}
        onMouseDown={(event) => {
          event.preventDefault();
        }}
        onClick={onClick}
        sx={buttonSx(!!active)}
        size="small"
      >
        <AppIcon iconName={icon} diameter={iconSize} color="currentColor" />
      </IconButton>
    </span>
  </Tooltip>
);

export const buttonSx =
  (active: boolean) =>
  ({ backrs }: Theme): SystemStyleObject<Theme> => ({
    color: active ? backrs.colors['Brand/700'] : backrs.colors['Gray/600'],
    backgroundColor: active ? backrs.colors['Brand/50'] : 'transparent',
    borderRadius: backrs.radius['radius-sm'],
    '&:hover': {
      backgroundColor: active ? backrs.colors['Brand/100'] : backrs.colors['Gray/100'],
      color: active ? backrs.colors['Brand/700'] : backrs.colors['Gray/800'],
    },
  });
